import MediaGallery from './MediaGallery';

/** A stock unit's photos and illustrative images (MERCH-59, MERCH-77): the shared gallery for inventory_unit. */
export default function UnitPhotos({ unitId }) {
  return <MediaGallery ownerType="inventory_unit" ownerId={unitId} />;
}
